import React from 'react';
import Header from '../components/Header/Header';
import ProjectsBlock from '../components/ProjectsBlock/ProjectsBlock';
import Partners from '../components/Partners/Partners';
import './Projects.css';

const Projects = () => {
  return (
    <div className="page-wrapper">
      <div className="hero-wrapper">
        <Header />
        <div className="page-hero">
          <div className="page-hero-overlay"></div>
          <div className="page-hero-content">
            <h1>Our Projects</h1>
            <p>Showcasing our recent electrical and installation work</p>
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="active">Projects</span>
            </div>
          </div>
        </div>
      </div>

      <ProjectsBlock />
      <Partners />
    </div>
  );
};

export default Projects;
